import React, { Component } from "react";
import { connect } from "react-redux";
import { func } from "prop-types";
import FlagRenderer from "../FlagRenderer";
import RoundIcon from "../RoundIcon";
import Icon from "../Icon";
import "./style.css";
import PageContent from "../PageContent";
import { selectDocumentType } from "../../logic/actions/documentCapture";
import { go } from "../../logic/actions/navigation";
import { DOCUMENT_COUNTRY_SELECTOR } from "../../logic/enums/pages";
import { countrySelector } from "../../logic/actions/documentCapture";

import {
  PASSPORT,
  DRIVERS_LICENCE,
  ID_CARD,
  OTHER_DOCUMENT,
} from "../../logic/enums/documentType";
import { DOCUMENT_CAPTURE_INSTRUCTIONS } from "../../logic/enums/pages";
import { setDocumentQualityRetries } from "../../logic/actions/documentCapture";

export class PageVerifyIdentity extends Component {
  static propTypes = {
    selectDocumentType: func,
    go: func,
  };

  constructor(props) {
    super(props);
    this.go.bind(this);
    this.goToPassport.bind(this);
    this.goToIdCard.bind(this);
    this.goToDriversLicence.bind(this);
  }

  componentDidMount() {
    if (this.props.documentQualityRetries) {
      this.props.setDocumentQualityRetries(
        parseInt(this.props.documentQualityRetries)
      );
    } else {
      this.props.setDocumentQualityRetries(3);
    }
  }

  componentWillMount() {
    switch (this.props.dialCountryNum) {
      case "us":
        this.props.countrySelector({ id: 0, dl: 2 });
        this.setState({ message: "USA" });

        break;
      case "gb":
        this.props.countrySelector({ id: 0, dl: 1 });
        this.setState({ message: "United Kingdom" });

        break;
      case "ie":
        this.props.countrySelector({ id: 0, dl: 1 });
        this.setState({ message: "Ireland" });

        break;
      case "au":
        this.props.countrySelector({ id: 0, dl: 1 });
        this.setState({ message: "Australia" });

        break;
      case "nz":
        this.props.countrySelector({ id: 0, dl: 2 });
        this.setState({ message: "New Zealand" });

        break;
      default:
        this.props.countrySelector({ id: undefined, dl: undefined });
        this.setState({ message: "Other" });
    }
  }

  goToPassport = () => this.go(PASSPORT);

  goToCountryPage = () => {
    this.props.go(DOCUMENT_COUNTRY_SELECTOR);
  };

  goToIdCard = () => this.go(ID_CARD);

  goToDriversLicence = () => this.go(DRIVERS_LICENCE);

  goToOtherDocument = () => this.go(OTHER_DOCUMENT);

  go = (type) => {
    this.props.selectDocumentType(type);
    this.props.go(DOCUMENT_CAPTURE_INSTRUCTIONS);
  };

  render() {
    const documentTextID =
      this.props.docCountryOptions.id === 1
        ? "Face photo page"
        : "Front and back";
    const documentTextDL =
      this.props.docCountryOptions.dl === 1
        ? "Face photo page"
        : "Front and back";

    return (
      <PageContent progressBar={true} progressPercentage={60}>
        <h1>Verify your identity</h1>
        <p className="center">
          Select the type of document you would like to upload.
        </p>
        <p style={{ marginTop: "5em" }}>
          <strong>Nationality</strong>
        </p>
        <div>
          <div
            className="panel-doc-type"
            style={{ marginBottom: "6em", marginTop: "0px" }}
          >
            <FlagRenderer flag={this.props.dialCountryNum} />
            {this.state.message}
            <div className="w-full">
              <p
                style={{ color: "blue", float: "right", marginRight: "2em" }}
                onClick={this.goToCountryPage}
              >
                Change
              </p>
            </div>
          </div>
        </div>
        <p>
          <strong>Select a document</strong>
        </p>
        <div
          className="panel-doc-type"
          data-type={PASSPORT}
          onClick={this.goToPassport}
        >
          <RoundIcon color="blue">
            <Icon name="Passport" color="white" />
          </RoundIcon>
          <div className="w-full">
            <Icon
              name="Chevron-r"
              color="gray"
              small="true"
              className="chevron m-20"
            />
            <div>
              <h2>Passport</h2>
              <p>Face photo page</p>
            </div>
          </div>
        </div>
        {this.props.docCountryOptions.dl !== 0 ? (
          <div className="panel-doc-type" onClick={this.goToDriversLicence}>
            <RoundIcon color="blue">
              <Icon name="Drivers-license" color="white" />
            </RoundIcon>
            <div className="w-full">
              <Icon
                name="Chevron-r"
                color="gray"
                small="true"
                className="chevron m-20"
              />
              <div>
                <h2>Driver's licence</h2>
                <p>{documentTextDL}</p>
              </div>
            </div>
          </div>
        ) : null}
        {this.props.docCountryOptions.id !== 0 ? (
          <div className="panel-doc-type" onClick={this.goToIdCard}>
            <RoundIcon color="blue">
              <Icon name="ID-card" color="white" />
            </RoundIcon>
            <div className="w-full">
              <Icon
                name="Chevron-r"
                color="gray"
                small="true"
                className="chevron m-20"
              />
              <div>
                <h2>Identity card</h2>
                <p>{documentTextID}</p>
              </div>
            </div>
          </div>
        ) : null}

        <div className="panel-doc-type" onClick={this.goToOtherDocument}>
          <RoundIcon noDoc="noDoc" color="blue">
            {/* <Icon name="ID-card" color="white" /> */}
          </RoundIcon>
          <div className="w-full">
            <Icon
              name="Chevron-r"
              color="gray"
              small="true"
              className="chevron m-20"
            />
            <div>
              <h2>Other document </h2>
              <p>{documentTextID}</p>
            </div>
          </div>
        </div>
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    return {
      ...state.configuration.extraConfig.featureFlags,
      ...state.documentCapture,
    };
  },
  { selectDocumentType, go, setDocumentQualityRetries, countrySelector }
)(PageVerifyIdentity);
